/* eslint-disable filenames/match-exported */
import React, { useEffect } from "react";
import { makeStyles, createStyles, Theme as AugmentedTheme } from "@material-ui/core/styles";
import Props from "./index.d";
import Select from "components/atomics/Select";
import FormHeader from "components/atomics/FormHeader";
import { useGetMoodleModulsLazyQuery } from "graphqlBase/MoodleModul/__generated__/getMoodleModuls";
import { useGetModulsLazyQuery } from "graphqlBase/Modul/__generated__/getModuls";
import { SortEnumType } from "graphqlBase/types";
const useStyles = makeStyles(
  (theme: AugmentedTheme) =>
    createStyles({
      foreignKeySelectorIntBox: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      },
    }),
  { name: "foreignKeySelector" }
);
const ForeignKeySelectorIntModul: React.FC<Props> = (props) => {
  const {
    data: { state, setAndSave },
    disabled,
    title,
    pickDefaultFirst,
    label,
    noHeader,
    errors,
    noFormControlMarginTop = false,
  } = props;
  const [query, { data }] = useGetModulsLazyQuery({
    fetchPolicy: "cache-and-network",
    variables: { order: { modulName: "ASC" as SortEnumType } },
  });
  useEffect(() => {
    query();
  }, [query]);
  const elems = data?.moduls?.map((modul) => {
    return {
      value: modul?.id ?? 0,
      label: `${modul?.modulNameIntern} - (${modul?.studiengangTyp?.studiengangTypKuerzel})`,
    };
  });

  useEffect(() => {
    if (pickDefaultFirst && !state && !!elems && elems.length) setAndSave(elems[0]?.value);
  }, [elems, state, pickDefaultFirst, setAndSave]);

  const classes = useStyles(props);
  return (
    <div className={classes.foreignKeySelectorIntBox}>
      {!noHeader && <FormHeader title={title} />}

      <Select
        label={title}
        setState={(value) => setAndSave(+value)}
        state={state}
        items={elems ?? []}
        disabled={disabled}
        error={!!errors?.length}
        helperText={errors?.join(" ") ?? undefined}
        noFormControlMarginTop={noFormControlMarginTop}
        readonly={props.readonly}
      />
    </div>
  );
};

export default ForeignKeySelectorIntModul;
